module.exports = __webpack_public_path__ + "media/loans/father-son-c09ab9c4.webp";